document.addEventListener('DOMContentLoaded', () => {
    const allTabs = document.querySelectorAll('.service-tab');

    if (!allTabs || allTabs.length === 0) return;

    const updateTabs = (tab) => {
        // Scope queries to the closest interactive section
        const container = tab.closest('.services-tabs, .seo-tabs, section') || document;
        
        const index = tab.getAttribute('data-service-index');
        const serviceId = tab.getAttribute('data-service-id');

        // --- Toggle Tab Active State ---
        const containerTabs = container.querySelectorAll('.service-tab');
        containerTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        // --- Toggle Image Sync ---
        const containerImages = container.querySelectorAll('.service-image');
        containerImages.forEach(img => {
            const imgIndex = img.getAttribute('data-service-index');
            if (imgIndex === index) {
                img.classList.add('active');
            } else {
                img.classList.remove('active');
            }
        });

        // --- Toggle Description Sync (if applicable) ---
        const containerDescs = container.querySelectorAll('.service-description');
        containerDescs.forEach(desc => {
            const descIndex = desc.getAttribute('data-service-index');
            if (descIndex === index) {
                desc.classList.add('active');
            } else {
                desc.classList.remove('active');
            }
        });

        // --- Update ID Text ---
        const activeIdText = container.querySelector('.active-id');
        if (activeIdText && serviceId) {
            activeIdText.textContent = serviceId;
        }

        // --- Update Link Buttons ---
        const serviceLink = tab.getAttribute('data-service-link') || '';
        const serviceBtnText = tab.getAttribute('data-service-btn-text') || 'View Details';
        const viewDetailsBtn = container.querySelector('.btn-view-details:not(.tab-nav-btn)');
        const arrowBtn = container.querySelector('.btn-arrow');
        const serviceActions = container.querySelector('.service-actions');

        if (serviceLink) {
            if (viewDetailsBtn) {
                viewDetailsBtn.setAttribute('href', serviceLink);
                const textEl = viewDetailsBtn.querySelector('.btn-text');
                if (textEl) textEl.textContent = serviceBtnText;
            }
            if (arrowBtn) arrowBtn.setAttribute('href', serviceLink);
            if (serviceActions) serviceActions.style.display = '';
        } else {
            if (serviceActions) serviceActions.style.display = 'none';
        }

    };

    allTabs.forEach(tab => {
        tab.addEventListener('mouseenter', () => updateTabs(tab));
        tab.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            updateTabs(tab);

            if (window.innerWidth <= 1024) {
                setTimeout(() => {
                    const header = document.querySelector('.site-header');
                    const headerHeight = header ? (header.getBoundingClientRect().height || header.offsetHeight || 0) : 80;
                    const adminBar = document.getElementById('wpadminbar');
                    const adminBarHeight = adminBar ? (adminBar.getBoundingClientRect().height || adminBar.offsetHeight || 0) : 0;
                    const offset = headerHeight + adminBarHeight + 20;

                    const rect = tab.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const targetY = rect.top + scrollTop - offset;

                    window.scrollTo({
                        top: Math.max(0, targetY),
                        behavior: 'smooth'
                    });
                }, 50);
            }
        });
    });
});
